import { Component, Vue, Prop } from 'vue-property-decorator'

@Component

export default class SelectTabs extends Vue {
  
  @Prop()
  private tabsName!: string;

  @Prop()
  private selectTabs!: string[];

  @Prop()
  private defaultSelected!: number;

  @Prop()
  private themeColor!: string;

  private activeTab: number = this.defaultSelected;

  protected set SelectTab (options: {index: number, name: string}) {

    const number = options.name.replace( /\D+$/g, '');

    this.activeTab = options.index;

    this.$emit('set-report', {
      type: this.tabsName, 
      index: options.index, 
      length: parseInt(number)
    });
  }

  protected get SelectTab () {

    return {index: this.activeTab, name: this.selectTabs[this.activeTab]};
  }
}